import { useEffect } from "react";

import { getCLS, getFID, getLCP, getFCP, getTTFB } from "web-vitals";
import { PAGE_VIEWED, DEFAULT_CURRENCY } from "config/trackingConsts";
import config from "config/config";
import { isChrome, pagePath, pageUrl } from "utils/browserUtils";

const tagManagerArgs = {
  gtmId: config.gtmCode,
};

const sendToDataLayer = ({ name, delta }) => {
  const value = name === "CLS" ? Math.round(delta * 100) / 100 : Math.round(delta);
  window.dataLayer.push({ event: name, value });
};

const pageSpeedMetrics = () => {
  getCLS(sendToDataLayer);
  getFID(sendToDataLayer);
  getLCP(sendToDataLayer);
  getFCP(sendToDataLayer);
  getTTFB(sendToDataLayer);
};

const getPageViewedData = (language, pageType, title) => {
  const pageViewedData = {
    type: pageType,
    locale: language,
    link: pageUrl(),
    title,
    pagePath: pagePath(),
  };

  return pageViewedData;
};

const pushPageViewed = (pageViewedData) => {
  const { type, locale, title, link } = pageViewedData;

  window.dataLayer.push({
    userAgent: navigator.userAgent,
    pageUrl: link,
    pagePath: pagePath(),
    pageTitle: title,
    pageType: type,
    pageLanguage: locale,
    pageCurrency: DEFAULT_CURRENCY,
    event: PAGE_VIEWED,
    url: link,
  });
};

const initializeTracking = () => {
  import("react-gtm-module").then((TagManager) => {
    TagManager.initialize(tagManagerArgs);
  });
};

const trackPageViewed = (language, pageType) => {
  const { title } = document;
  if (!window.dataLayer) window.dataLayer = [];
  if (isChrome) pageSpeedMetrics();

  const pageViewedData = getPageViewedData(language, pageType, title);
  pushPageViewed(pageViewedData);
};

const useGTM = (language, pageType, isTrackingLess) => {
  useEffect(() => {
    if (!isTrackingLess) {
      initializeTracking();
      trackPageViewed(language, pageType);
    }
  }, [language, pageType, isTrackingLess]);
};

export default useGTM;
